/*  MUI  */
import { Box, Typography } from '@mui/material';

/*  Shared  */
import CustomScript from 'application/Shared/Components/CustomScript/Containers/CustomScript';

/* Hooks */
import { useUserTheme } from 'hooks/dataAccess/User/userTheme';

/*  React  */
import React from 'react';
import { useTranslation } from 'react-i18next';

/*  Components  */
import { IntegrationWrapper } from './Components/IntegrationWrapper';

const deploymentSteps = ({ onboarding, t }) => [
    {
        component: (
            <Typography variant="h4">
                {t('Integrations.setup_process')}
            </Typography>
        ),
        step: false
    },
    {
        note: (
            <Box>
                <ul>
                    <li className="li-with-spacing">
                        {t('Integrations.Intune.note1')}
                    </li>
                    <li className="li-with-spacing">
                        {t('Integrations.Intune.note2')}
                    </li>
                    <li className="li-with-spacing">
                        {t('Integrations.Intune.note3')}
                    </li>
                    <li className="li-with-spacing">
                        {t('Integrations.Intune.note5')}
                    </li>
                </ul>
            </Box>
        ),
        step: false
    },
    {
        component: (
            <Typography
                dangerouslySetInnerHTML={{
                    __html: t('Integrations.Intune.step1')
                }}
            />
        ),
        step: true
    },
    { component: t('Integrations.Intune.step2'), step: true },
    {
        component: (
            <Box>
                {t('Integrations.Intune.step3')}
                <CustomScript forIntune onboarding={onboarding} />
            </Box>
        ),
        step: true
    },
    { component: t('Integrations.Intune.step4'), step: true },
    {
        component: (
            <Box>
                <Typography
                    dangerouslySetInnerHTML={{
                        __html: t('Integrations.Intune.step5')
                    }}
                />
                <ul style={{ paddingBottom: 0 }}>
                    <li className="li-with-spacing">
                        <Typography
                            dangerouslySetInnerHTML={{
                                __html: t('Integrations.Intune.step5.a')
                            }}
                        />
                    </li>
                    <li className="li-with-spacing">
                        <Typography
                            dangerouslySetInnerHTML={{
                                __html: t('Integrations.Intune.step5.b')
                            }}
                        />
                    </li>
                    <li className="li-with-spacing">
                        <Typography
                            dangerouslySetInnerHTML={{
                                __html: t('Integrations.Intune.step5.b2')
                            }}
                        />
                    </li>
                    <li className="li-with-spacing">
                        <Typography
                            dangerouslySetInnerHTML={{
                                __html: t('Integrations.Intune.step5.c')
                            }}
                        />
                    </li>
                </ul>
            </Box>
        ),
        step: true
    },
    { component: t('Integrations.Intune.step6'), step: true },
    { component: t('Integrations.Intune.step7'), step: true }
];

export const Intune = ({ onboarding = false }) => {
    const { t } = useTranslation();
    const userTheme = useUserTheme();

    return (
        <IntegrationWrapper
            hasToken
            deploymentSteps={deploymentSteps({ onboarding, t })}
            headerTitle={t('Integrations.Intune.title')}
            img={`/images/${userTheme}/integrations/intune.png`}
            imgWidth="200px"
            onboarding={onboarding}
        />
    );
};
